import { PropsWithChildren } from 'react';
import useGuest from 'hooks/useGuest';
import { animationPreferences } from 'services/animationPreferences';

import { AnimationPreferencesProvider } from './AnimationPreferencesContext';

/**
 * The app root's AnimationPreferencesProvider, fed the token-backed guest
 * session and the player-api request. Kept out of AnimationPreferencesContext
 * for the same reason as SessionFeatureFlagProvider: both import the auth
 * module (and through it the store), which animated components' tests must not
 * load.
 */
export const SessionAnimationPreferencesProvider = ({ children }: PropsWithChildren) => (
  <AnimationPreferencesProvider request={animationPreferences} guestSession={useGuest()}>
    {children}
  </AnimationPreferencesProvider>
);
